<template>
  <el-input
    v-bind="$attrs"
    :value="value"
    :clearable="clearable"
    @input="onInput"
    @clear="searchHandler"
    @keyup.enter.native="enterHandler"
    :style="{ width: width }"
    class="custom-search-input"
  >
    <template slot="append" v-if="!authSearch">
      <div @click="searchHandler">
        <i class="icon icon-search"></i>
      </div>
    </template>
  </el-input>
</template>

<script>
export default {
  props: {
    value: [String, Number],
    width: {
      type: String,
      default: '260px'
    },
    clearable: {
      type: Boolean,
      default: true
    },
    // 不显示右侧搜索按钮，输入时自动搜索
    authSearch: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      changeHandler: () => {}
    };
  },
  methods: {
    enterHandler() {
      this.$emit('enter');
      this.$emit('fetch');
    },
    searchHandler() {
      this.$emit('search');
      this.$emit('fetch');
    },
    onChange() {
      this.searchHandler();
    },
    onInput(e) {
      this.$emit('input', e);
      this.changeHandler();
    }
  },
  created() {
    if (this.authSearch) {
      this.changeHandler = this.$debounce(this.onChange, 500);
    }
  }
};
</script>

<style lang="scss">
.custom-search-input {
  .el-input-group__append {
    width: 32px;
  }
}
</style>
